import styles from "./pagination.module.css";

interface PaginationItemProps {
  number: number;
  isCurrent?: boolean;
  onPageChange: (page: number) => void;
}

export const PaginationItem = ({
  isCurrent = false,
  number,
  onPageChange,
}: PaginationItemProps) => {
  const pageItemClass = `${styles.pageItem} ${isCurrent ? styles.current : ""}`;

  return (
    <button
      className={pageItemClass}
      onClick={() => !isCurrent && onPageChange(number)}
      data-testid="page-number"
      type="button"
    >
      {number}
    </button>
  );
};
